import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge doesn't know about custom @theme values by default, so the
// `modal` shadow (index.css's --shadow-modal) isn't recognized as conflicting
// with the standard shadow scale (shadow-xs, shadow-md, ...).
const twMerge = extendTailwindMerge({ extend: { theme: { shadow: ['modal'] } } });

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
